<template>
    <spinner v-if="isLoading"/>
    <section v-else>
        <table>
            <thead>
                <tr>
                    <th :class="{'currentSort':sortkey=='title'}" @click="sortKey" data-sortkey="title">Title</th>
                    <th :class="{'currentSort':sortkey=='year'}" @click="sortKey" data-sortkey="year">Year</th>
                    <th :class="{'currentSort':sortkey=='school_code'}" @click="sortKey" data-sortkey="school_code">School</th>
                    <th :class="{'currentSort':sortkey=='dept_code'}" @click="sortKey" data-sortkey="dept_code">Department</th>
                    <th :class="{'currentSort':sortkey=='primary_supervisor_name'}" @click="sortKey" data-sortkey="primary_supervisor_name">Supervisor</th></tr>
            </thead>
            <tbody><tr v-for="proj in projectList" :key="proj.id" @click="showDetails" :data-id="proj.id">
                <td>{{proj.title}}</td>
                <td>{{proj.year}}</td>
                <td>{{getSchool(proj.school_code)}}</td>
                <td>{{getDept(proj.school_code,proj.dept_code)}}</td>
                <td>{{proj.primary_supervisor_name||proj.supervisor_upi}}</td>
            </tr></tbody>
        </table>
        <div :class="{'show':project!=undefined}" class="blanket" @click="project=undefined">
            <div v-if="project">
                <h2 class="rev">{{project.title}}</h2>
                <section class="row">
                <staff-contact v-for="upi in project.supervisor_upi.split(';')" :key="upi" :upi="upi" />
                <table class="side-table">
                    <tbody>
                        <tr>
                            <td>Department</td><td v-html="getSchoolAndDept(project)"></td>
                        </tr>
                        <tr>
                            <td>Project type</td><td>Honours</td>
                        </tr>
                        <tr>
                            <td>Ethics status</td><td>{{getEthics()}}</td>
                        </tr>
                        <tr v-if="project.is_interfaculty">
                            <td>Interfaculty</td><td>Yes</td>
                        </tr>
                    </tbody>
                </table>
                </section>
                <h3>Aims</h3>
                <main v-html="project.aim" class="multicol"></main>
            </div>
        </div>
    </section>
</template>

<script>
import staffContact from './staffContact.vue'
import spinner from './spinner.vue'

function setSortKey(event, rows) {
    let sk = event.target.dataset.sortkey;
    if (this.sortkey != sk) {
        this.sortkey = sk;
        let isNumber = parseInt(rows[0][sk]);
        rows.sort(function (a, b) {
            let astr = a[sk] ?? 'zzzzzzz'
            let bstr = b[sk] ?? 'zzzzzzz'
            return (isNumber?bstr*1-astr*1:astr.localeCompare(bstr));
        });
    }
}

export default {
  name: 'ProjectList',
  components: {staffContact,spinner},
  props: {
    msg: String
  },
  data: function () {
      return {
          sortkey: "title",
          isLoading: true,
          thePath: process.env.VUE_APP_ENDP1,
          supervisors: [],
          project: undefined,
          codes: {},
          projectList: []
      }
  },
  methods: {
    getDept: function(sc,dc){
        return this.codes[sc].d[dc]||dc;
    },
    getSchool: function(sc){
        return this.codes[sc].n||sc;
    },
    getSchoolAndDept: function(project){
        // return department and school unless they are the same
        let s = this.getSchool(project.school_code);
        let d = this.getDept(project.school_code,project.dept_code);
        let rv = d;
        if (s != d)
            rv += ",<br/>" + s;
        return rv;
    },
    getEthics: function(){
        let eth = (this.project.ethics_approved)?"Approved":"Not required";
        if (this.project.ethics_required){
            eth = "Required";
            if (this.project.ethics_approved){
                eth = "Approved";
            } else {
                if (this.project.ethics_applied == true)
                    eth += " and applied for";
                else
                    eth += " but not applied for";
            }
        }
        return eth;
    },
    showDetails: function(e){
        let id = e.target.parentElement.dataset.id;
        this.getDetails(id);
    },
    getDetails: async function(id){
        const resp = await fetch(process.env.VUE_APP_ENDP1+"?id="+id,
        { method: 'GET', mode: 'cors', credentials: 'include' });
        const json = await(resp.json());
        // decode title text
        this.project = json;
    },
    sortKey: function(e){
        setSortKey.call(this,e,this.projectList);
    },
  },
  created: async function(){
    console.log(process.env.VUE_APP_ENDP1);
    //const resp = await fetch(process.env.VUE_APP_ENDP1);
    const resp = await fetch(process.env.VUE_APP_ENDP1,
    { method: 'GET', mode: 'cors', credentials: 'include' });
    const json = await(resp.json());
    this.projectList = json.projects.filter(prj=>prj.title.trim().length);
    this.codes = json.schoolcodes;
    this.isLoading = false;
  },
}
</script>

<style>
.row {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}
.side-table {
    display: inline-block;
    width: auto;
    min-width: 500px;
    font-size: 1.2rem;
    margin-block: auto;
}
.side-table>tbody>tr>td {
    white-space: pre;
}
.side-table>tbody>tr>td:first-of-type {
    white-space: nowrap;
    font-weight: bold;
}
.blanket {
    position: fixed;
    display: flex;
    left:0;
    right:0;
    top:0;
    bottom: 0;
    overflow-y: auto;
    background-color: rgba(0,0,0,0.8);
    opacity: 0;
    pointer-events: none;
    transition: opacity 200ms ease;
}
.blanket>div{
    width:80vw;
    max-width: 100ch ;
    background-color: var(--color-light-1);
    margin: auto;
    overflow: auto;
    padding: 0.75rem;
}
@media screen and (max-width: 900px) {
    .blanket>div {
        margin: auto 0;
        width: auto;
    }
}
.blanket.show {
    opacity: 1;
    pointer-events: all;
}
.contactBox {
    position: relative;
}
.contactBox:first-of-type:not(:only-of-type)::before {
    content: "Primary supervisor";
    position: absolute;
    writing-mode: vertical-rl;
    right:0;
    bottom:25%;
}
.rev {
    position: relative;
    color: white;
    font-weight: 400;
    z-index: 3;
    padding-bottom: 0.75rem;
}
.rev::after {
    content:"";
    position: absolute;
    left:-0.75rem;
    right:-0.75rem;
    top:-0.75rem;
    bottom: -0.25rem;
    background-color: var(--color-primary);
    z-index: -1;
}
.rev::before {
    content:"✚";
    float: right;
    transform: rotate(45deg) scale(1.2);
    cursor: pointer;
}
</style>
